import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import React from 'react';
import Animated from "react-native-web/dist/exports/Animated";
import Platform from "react-native-web/dist/exports/Platform";
import processColor from "react-native-web/dist/exports/processColor";
import StyleSheet from "react-native-web/dist/exports/StyleSheet";
import createNativeWrapper from "./createNativeWrapper";
import GestureHandlerButton from "./GestureHandlerButton";
import State from "./State";
export var RawButton = createNativeWrapper(GestureHandlerButton, {
  shouldCancelWhenOutside: false,
  shouldActivateOnStart: false
});
export var BaseButton = function (_React$Component) {
  _inherits(BaseButton, _React$Component);

  var _super = _createSuper(BaseButton);

  function BaseButton(props) {
    var _this;

    _classCallCheck(this, BaseButton);

    _this = _super.call(this, props);

    _this._handleEvent = function (_ref) {
      var nativeEvent = _ref.nativeEvent;
      var state = nativeEvent.state,
          oldState = nativeEvent.oldState,
          pointerInside = nativeEvent.pointerInside;
      var active = pointerInside && state === State.ACTIVE;

      if (active !== _this._lastActive && _this.props.onActiveStateChange) {
        _this.props.onActiveStateChange(active);
      }

      if (oldState === State.ACTIVE && state !== State.CANCELLED && _this._lastActive && _this.props.onPress) {
        _this.props.onPress(active);
      }

      _this._lastActive = active;
    };

    _this._onHandlerStateChange = function (e) {
      _this.props.onHandlerStateChange && _this.props.onHandlerStateChange(e);

      _this._handleEvent(e);
    };

    _this._onGestureEvent = function (e) {
      _this.props.onGestureEvent && _this.props.onGestureEvent(e);

      _this._handleEvent(e);
    };

    _this._lastActive = false;
    return _this;
  }

  _createClass(BaseButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          style = _this$props.style,
          rippleColor = _this$props.rippleColor,
          rest = _objectWithoutProperties(_this$props, ["style", "rippleColor"]);

      return React.createElement(RawButton, _extends({
        style: [{
          overflow: 'hidden'
        }, style],
        rippleColor: processColor(rippleColor)
      }, rest, {
        onGestureEvent: this._onGestureEvent,
        onHandlerStateChange: this._onHandlerStateChange
      }));
    }
  }]);

  return BaseButton;
}(React.Component);
var AnimatedBaseButton = Animated.createAnimatedComponent(BaseButton);
var btnStyles = StyleSheet.create({
  underlay: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    top: 0
  }
});
export var RectButton = function (_React$Component2) {
  _inherits(RectButton, _React$Component2);

  var _super2 = _createSuper(RectButton);

  function RectButton(props) {
    var _this2;

    _classCallCheck(this, RectButton);

    _this2 = _super2.call(this, props);

    _this2._onActiveStateChange = function (active) {
      if (Platform.OS !== 'android') {
        _this2._opacity.setValue(active ? _this2.props.activeOpacity : 0);
      }

      _this2.props.onActiveStateChange && _this2.props.onActiveStateChange(active);
    };

    _this2._opacity = new Animated.Value(0);
    return _this2;
  }

  _createClass(RectButton, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          rest = _objectWithoutProperties(_this$props2, ["children"]);

      return React.createElement(BaseButton, _extends({}, rest, {
        onActiveStateChange: this._onActiveStateChange
      }), React.createElement(Animated.View, {
        style: [btnStyles.underlay, {
          opacity: this._opacity
        }, {
          backgroundColor: this.props.underlayColor
        }]
      }), children);
    }
  }]);

  return RectButton;
}(React.Component);
RectButton.defaultProps = {
  activeOpacity: 0.105,
  underlayColor: 'black'
};
export var BorderlessButton = function (_React$Component3) {
  _inherits(BorderlessButton, _React$Component3);

  var _super3 = _createSuper(BorderlessButton);

  function BorderlessButton(props) {
    var _this3;

    _classCallCheck(this, BorderlessButton);

    _this3 = _super3.call(this, props);

    _this3._onActiveStateChange = function (active) {
      if (Platform.OS !== 'android') {
        _this3._opacity.setValue(active ? _this3.props.activeOpacity : 1);
      }

      _this3.props.onActiveStateChange && _this3.props.onActiveStateChange(active);
    };

    _this3._opacity = new Animated.Value(1);
    return _this3;
  }

  _createClass(BorderlessButton, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          style = _this$props3.style,
          rest = _objectWithoutProperties(_this$props3, ["children", "style"]);

      return React.createElement(AnimatedBaseButton, _extends({}, rest, {
        onActiveStateChange: this._onActiveStateChange,
        style: [style, Platform.OS === 'ios' && {
          opacity: this._opacity
        }]
      }), children);
    }
  }]);

  return BorderlessButton;
}(React.Component);
BorderlessButton.defaultProps = {
  activeOpacity: 0.3,
  borderless: true
};
export { default as PureNativeButton } from "./GestureHandlerButton";